import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Modal from '@bd/bdui-modal';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
// import { colors, typography } from '../../styles';

const modalStyles = css`
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  width: auto;
  margin: 0;
  height: auto;
  background-color:#FFFFFF;
  @media (min-width: 991px) {
    top: 30px;
    left: 50%;
    right: auto;
    width: 800px;
    margin-left: -400px;
  }
  img {
    max-width: 100%;
  }
  .PlatMapModal_close {
    display: block;
    position: absolute;
    right: 15px;
    top: 15px;
    width: 15px;
    height: 15px;
    padding: 0;
    box-sizing: content-box;
    background-image: url('/images/icon-close.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 15px 15px;
    background-color: transparent;
    border: 0;
    cursor: pointer;
    z-index: 2;
  }
`;

const modalOverlayStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background-color: rgba(0,0,0, 0.75);
  overflow-y: auto;
`;


class PlatMapModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(e) {
    let currentElem = e.target;

    while (currentElem.tagName !== 'A' && currentElem.parentNode !== document) {
      currentElem = currentElem.parentNode;
    }

    if (currentElem.nodeName !== 'A') {
      e.preventDefault();
      this.setState({
        modalIsOpen: true,
      });
    }
  }

  closeModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ modalIsOpen: false });
  }

  render() {
    const { children, home } = this.props;
    return (
      <div>
        <span role="button" tabIndex={0} onClick={this.openModal}>
          {children}
        </span>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Contact Modal"
          className={modalStyles}
          overlayClassName={modalOverlayStyles}
        >
          <button className="PlatMapModal_close" onClick={this.closeModal} />
          <img src={buildThumbnailUrl(get(home, 'plat_map.contentUrl'), { height: 800, width: 800 })} alt="" />
        </Modal>
      </div>
    );
  }
}

PlatMapModal.propTypes = {
  home: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default PlatMapModal;



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/PlatmapModal.js